interface RelativeLocation {
  pathname: string;
  search?: string;
  hash?: string;
}

export function getRelativeLocationUrl({
  pathname,
  search = "",
  hash = "",
}: RelativeLocation): string {
  return `${pathname}${search}${hash}`;
}
